// GENERATED FILE, PLEASE DO NOT EDIT
var None = 0;
var XxxxSmall = 2;
var XxxSmall = 4;
var XxSmall = 8;
var XSmall = 12;
var Small = 16;
var Medium = 20;
var Large = 24;
var XLarge = 32;
var XxLarge = 48;
var XxxLarge = 64;
var XxxxLarge = 96;
var SpacingTokensAll = {
  Large: Large,
  Medium: Medium,
  None: None,
  Small: Small,
  XLarge: XLarge,
  XSmall: XSmall,
  XxLarge: XxLarge,
  XxSmall: XxSmall,
  XxxLarge: XxxLarge,
  XxxSmall: XxxSmall,
  XxxxLarge: XxxxLarge,
  XxxxSmall: XxxxSmall
};

export { Large, Medium, None, Small, SpacingTokensAll, XLarge, XSmall, XxLarge, XxSmall, XxxLarge, XxxSmall, XxxxLarge, XxxxSmall, SpacingTokensAll as default };
